var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloud28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14282 16.5714C1.14282 20.9897 4.72454 24.5714 9.14282 24.5714H25.1428C28.2987 24.5714 30.8571 22.0131 30.8571 18.8571C30.8571 16.5043 29.4352 14.4837 27.4038 13.6076C27.0568 8.8748 23.107 5.14285 18.2857 5.14285C15.3016 5.14285 12.6515 6.57241 10.9827 8.78403C10.392 8.64499 9.776 8.57142 9.14282 8.57142C4.72454 8.57142 1.14282 12.1531 1.14282 16.5714Z",
    fill: "url(#paint0_linear_12038_8949)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12038_8949",
    x1: 1.14282,
    y1: 5.14285,
    x2: 18.9406,
    y2: 32.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8AE6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud28);
export default __webpack_public_path__ + "static/media/cloud_28.6115c200.svg";
export { ForwardRef as ReactComponent };